export default __webpack_public_path__ + "static/media/warning.635a7ae2.svg";